import { useAlert } from 'components/alert/AlertStack';
import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { Button } from 'components/Button';
import { FormAction } from 'components/form/FormAction';
import { FormField } from 'components/form/FormField';
import { FormGroup } from 'components/form/FormGroup';
import { FormInput } from 'components/form/FormInput';
import { FormSection } from 'components/form/FormSection';
import { FormSelect } from 'components/form/FormSelect';
import { MutationForm } from 'components/form/graphql/MutationForm';
import { UpdateClientMutation } from 'graphql/Client/mutations/UpdateClientMutation';
import { React } from 'libs/react';
import { useAccount } from 'components/account/AccountProvider';
import { useTranslation } from 'components/translation/TranslationProvider';
import { FormGoogleAutocompleteInput } from 'components/form/FormGoogleAutocompleteInput';
import './CreateClientPanel.scss';
/**
 * @component UpdateClientPanel
 * @since 1.0.0
 */
export function UpdateClientPanel(props) {
    var _a, _b, _c;
    const { style, client } = Object.assign({ style: 'normal' }, props);
    const alert = useAlert();
    const account = useAccount();
    const { customLabels, language } = useTranslation();
    const [locationId, setLocationId] = useState(((_a = client.primaryLocation) === null || _a === void 0 ? void 0 : _a.id) || null);
    const [location, setLocation] = useState(client.primaryLocation
        ? {
            civicNumber: client.primaryLocation.civicNumber || '',
            road: client.primaryLocation.road || '',
            apartment: client.primaryLocation.apartment || '',
            city: client.primaryLocation.city || '',
            province: client.primaryLocation.province || '',
            country: client.primaryLocation.country || '',
            postalcode: client.primaryLocation.postalcode || '',
            latitude: client.primaryLocation.latitude || 0,
            longitude: client.primaryLocation.longitude || 0
        }
        : null);
    /**
     * @function onProcess
     * @since 1.0.0
     * @hidden
     */
    function onProcess(values) {
        const { name, number, website, clientLanguage } = values;
        const input = {
            id: client.id,
            name,
            number,
            website,
            isEndClient: client.isEndClient,
            languageId: clientLanguage,
            location: locationId,
            locationValues: location
        };
        return {
            variables: {
                input
            }
        };
    }
    /**
     * @function onSuccess
     * @since 1.0.0
     * @hidden
     */
    function onSuccess(result) {
        var _a;
        alert.present({
            title: (React.createElement("p", null,
                React.createElement("strong", null, (_a = result === null || result === void 0 ? void 0 : result.updateClient) === null || _a === void 0 ? void 0 : _a.name),
                " ",
                t('has been updated.')))
        });
        if (props.onDone) {
            props.onDone(result.updateClient);
        }
    }
    /**
     * @function onFailure
     * @since 1.0.0
     * @hidden
     */
    function onFailure(error) {
        alert.present({ error });
    }
    const className = classNames('create-client-panel', 'create-client-panel--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(MutationForm, { name: "client-update-form", mutation: UpdateClientMutation, onProcess: onProcess, onSuccess: onSuccess, onFailure: onFailure, style: style },
            React.createElement(FormSection, { title: `${t('Edit')} ${customLabels['Client'][language]}`, style: style },
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { type: "text", name: "name", label: t('Name'), placeholder: t('Enter Name'), defaultValue: client.name, required: true }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { type: "text", name: "number", label: t('Number'), placeholder: t('Enter Number'), defaultValue: client.number || '', optional: true }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { type: "url", name: "website", label: t('Website'), placeholder: t('Enter Website'), defaultValue: client.website || '', optional: true }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormSelect, { name: "clientLanguage", label: t('Language'), placeholder: t('Select Language'), options: account.languages.map((lang) => ({
                                value: lang.id,
                                label: lang.name
                            })), defaultValue: ((_b = client.language) === null || _b === void 0 ? void 0 : _b.id) ||
                                ((_c = account.languages.find((lang) => lang.primary)) === null || _c === void 0 ? void 0 : _c.id), optional: true }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormGoogleAutocompleteInput, { name: "address", label: t('Address'), placeholder: t('Enter Address'), value: location
                                ? (location === null || location === void 0 ? void 0 : location.civicNumber) +
                                    ' ' +
                                    (location === null || location === void 0 ? void 0 : location.road) +
                                    ', ' +
                                    (location === null || location === void 0 ? void 0 : location.city) +
                                    ', ' +
                                    (location === null || location === void 0 ? void 0 : location.province) +
                                    ', ' +
                                    (location === null || location === void 0 ? void 0 : location.country)
                                : '', onLocationSelected: (location) => {
                                setLocation(location);
                                setLocationId(null);
                            } })))),
            React.createElement(FormAction, { align: "stretch" },
                props.onCancel && (React.createElement(Button, { style: "outline", label: t('Cancel'), onPress: props.onCancel })),
                React.createElement(Button, { style: "primary", label: `${t('Update')} ${customLabels['Client'][language]}`, badge: "arrow-right", submit: true })))));
}
